/**
 * Addons Form Components
 *
 */
class AddonsForm extends HTMLElement {
    constructor() {
    super();
        this.form = this;
        this.atc = document.querySelectorAll('[data-addon-submit]');
        this.minQtyThreshold = 10
        this.currentInventory = document.querySelector('[data-inventory-quantity]')?.dataset.inventoryQuantity
        this.atc.forEach(atc => atc.addEventListener('click', this.addAddonsProduct.bind(this)));
        this.cartElement = document.querySelector('ajax-cart');
    }

    async addAddonsProduct(event) {
         event.preventDefault();
            event.stopPropagation();


            let el = event.currentTarget;
        // restrict gift card purchase js
        // if(giftCardRestrict.enable_restrict_gift_card_purchasing == true){
        //     const isgiftcard = JSON.parse(el.getAttribute('isgiftcard'));
        //     let normal_product_popup = document.querySelector('[normal_product_popup]');
        //     let gift_product_popup = document.querySelector('[gift_product_popup]');
        //     let isgiftcardInCart = false;
        //     const getCartData = await this.getCart();
        //     if(getCartData.items.length > 0){
        //     getCartData.items.forEach((element) => {
        //         if(element.gift_card == true){
        //         isgiftcardInCart = true
        //         }
        //     })
        //     }
        //     if(isgiftcard == true && isgiftcardInCart == false && getCartData.items.length > 0 ){
        //         gift_product_popup.show();
        //         return false;
        //     }else if(isgiftcard == false && isgiftcardInCart == true && getCartData.items.length > 0){
        //         normal_product_popup.show();
        //         return false;
        //     }
        // }
        // restrict gift card purchase js END
        
        let addonsProductId;
        let inventoryQty;
        let variantsArray =[]
        if(el.hasAttribute("combinedATC"))   {
           
            document.querySelectorAll("[data-addonsproductid]").forEach(each=>{
                variantsArray.push(each.getAttribute('data-addonsproductid'))
              })
        }else{
             addonsProductId = el.getAttribute("data-addonsProductId") || null;
             inventoryQty = parseInt(el.getAttribute("data-inventory-quantity")) || 0;
        }
      console.log(variantsArray, 'variants---', inventoryQty)

        if(el.hasAttribute("combinedATC")){
            el.classList.add('loading');
            el.setAttribute('disabled', true);
        let cartData = {
                items: []
            };
            
            console.log(cartData, 'cartData');
            console.log(variantsArray, 'variantsArray');
            
            for (let i = 0; i < variantsArray.length; i++) {
                let item = {
                    id: variantsArray[i],
                    quantity: 1
                };
            
                // Check if the item already exists in cartData.items
                let exists = cartData.items.some(cartItem => cartItem.id === item.id);
            
                if (!exists) {
                    cartData.items.push(item);
                }
            }
            
            
            console.log(cartData, 'cartData');
            console.log(cartData, 'fdgh;klujsdgdshgkjdfs gkljdnsfhlkjghskhsdkjsdjgsdjgsdkjghsfgsfjg     cartdata');
            
            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(cartData),
            }).then(response => {
                // document.querySelector('ajax-cart').getCartData('open_drawer');
                el.classList.remove('loading');
                el.removeAttribute('disabled');

                let fetchCart = fetch(`/cart.js`);
                fetchCart.then(response => {
                    return response.json();
                }).then(response => {
                    let cartCountElements = document.querySelectorAll('.cart-count');
                    cartCountElements.forEach((div) => {
                        div.innerHTML = response.item_count;
                    });
                    
                }).catch((e) => {
                    // Rollbar.error(e);
                    console.error(e);
                }).finally(() => {
                    // Cart HTML fetch done
                });

                // el.querySelector('.add-text').innerHTML = 'Added !';
                setTimeout(() => {
                    if(el.querySelector('.add-text')){

                        el.querySelector('.add-text').innerHTML = 'Add to cart';
                    }
                    if (this.cartElement && typeof this.cartElement.getCartData === 'function') {
  this.cartElement.getCartData('open_drawer');
}
                }, 3000);
            });
        }else{
        if(addonsProductId != null  ){
            el.classList.add('loading');
            el.setAttribute('disabled', true);
            
            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    id: parseInt(addonsProductId),
                    quantity: 1
                })
            }).then(response => {
              //Pintrest tracking on Add To Cart
              pintrk('track', 'addtocart', {
                value: 100,
                order_quantity: 1,
                currency: 'USD'
              });
              // End Pintrest
                // document.querySelector('ajax-cart').getCartData('open_drawer');
                el.classList.remove('loading');
                el.removeAttribute('disabled');

                let fetchCart = fetch(`/cart.js`);
                fetchCart.then(response => {
                    return response.json();
                }).then(response => {
                    let cartCountElements = document.querySelectorAll('.cart-count');
                    cartCountElements.forEach((div) => {
                        div.innerHTML = response.item_count;
                    });
                    
                }).catch((e) => {
                    // Rollbar.error(e);
                    console.error(e);
                }).finally(() => {
                    // Cart HTML fetch done
                });

                el.querySelector('.add-text').innerHTML = 'Added !';
                setTimeout(() => {
                    el.querySelector('.add-text').innerHTML = 'Add to cart';
                            if (this.cartElement && typeof this.cartElement.getCartData === 'function') {
    this.cartElement.getCartData('open_drawer');
  }
                }, 3000);
            });
        }
           }
    }

    async getCart() {
        const result = await fetch("/cart.json");
    
        if (result.status === 200) {
            return result.json();
        }
    
        throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
    }

}
customElements.define('addons-form', AddonsForm);

